document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('[data-product-grid]');
  if (!section) return;

  var select = section.querySelector('[data-collection-select]');
  var grid = section.querySelector('[data-product-grid-list]');
  const title = document.querySelector('[data-collection-title]');

  function moneyFormat(amount) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(parseFloat(amount));
    } catch (e) {
      return parseFloat(amount).toFixed(0) + ' ' + currency;
    }
  }

  // Return the index of the "color" option for a product
  function getColorOptionIndex(product) {
    var colorNames = ['color', 'colour'];
    var idx = 0;
    if (product.options) {
      product.options.forEach(function (opt, i) {
        var name = typeof opt === 'string' ? opt : (opt.name || '');
        if (colorNames.indexOf(name.toLowerCase()) !== -1) idx = i;
      });
    }
    return idx;
  }

  // One card per unique color, points to ?variant=ID of the first variant of that color
  function expandByColor(products) {
    var cards = [];
    products.forEach(function (product) {
      var colorIdx = getColorOptionIndex(product);
      
      var seen = {};

      product.variants.forEach(function (variant) {
        var color = variant['option' + (colorIdx + 1)];
        if (seen[color]) return;
        seen[color] = true;

        // Image: prefer the variant image if available
        var variantFeaturedImage = variant.featured_image;
        var image = '';
        
        if (variantFeaturedImage) {     
          image = variantFeaturedImage.src;
        }
        
        if (!image && product.images && product.images.length) {
          image = product.images[0].src;
        }

        cards.push({
          url: '/products/' + product.handle + '?variant=' + variant.id,
          title: product.title,
          color: color,
          price: variant.price,
          image: image
        });
      });
    });
    return cards;
  }

  function renderProducts(products) {
    if (!products || !products.length) {
      grid.innerHTML = '<p>No products to display.</p>';
      return;
    }

    var cards = expandByColor(products);

    grid.innerHTML = cards.map(function (card) {
      return (
        '<a href="' + card.url + '" class="product-grid-card">' +
          '<div class="product-grid-card__image">' +
            (card.image ? '<img src="' + card.image + '&width=800" loading="lazy" alt="' + card.title + '">' : '') +
          '</div>' +
          '<div class="product-grid-card__info">' +
            '<span class="product-grid-card__title">' + card.title + '</span>' +
            '<span class="product-grid-card__price">' + moneyFormat(card.price) + '</span>' +
          '</div>' +
        '</a>'
      );
    }).join('');

    grid.style.opacity = '1';
  }

  function loadCollection(handle) {
    grid.style.opacity = '0.4';
    var url = handle
      ? '/collections/' + handle + '/products.json?limit=' + (section.dataset.limit || 24)
      : '/products.json?limit=' + (section.dataset.limit || 24);

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) { renderProducts(data.products); })
      .catch(function (err) {
        console.error('Error loading collection:', err);
        grid.style.opacity = '1';
      });
  }

  if (select) {
    select.addEventListener('change', function () {
      loadCollection(this.value);

      if (title) {
        const selectedOption = select.options[select.selectedIndex];
        title.textContent = selectedOption.text === 'All' ? 'All Products' : selectedOption.text;
      }
    });

    loadCollection(select.value);
  }
});